export const AngleDown = () => (
  <svg version="1.2" xmlns="http://www.w3.org/2000/svg" overflow="visible" preserveAspectRatio="none" viewBox="0 0 24 24">
    <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" vectorEffect="non-scaling-stroke" fill="currentColor"/>
  </svg>
);
